import { ResultCardHeaderButtonsProps } from './ResultCardHeaderButtons'
import React, { Fragment } from 'react'
import {
  useCopyLinkHeaderResultOption,
  useFeedbackHeaderResultOption,
  useSalesforceHeaderResultOption,
  useWealthboxHeaderResultOption,
  useZohoHeaderResultOption,
  useDynamicsHeaderResultOption,
  useSmartOfficeHeaderResultOption,
  useAdvisorEngineHeaderResultOption,
} from './HeaderResultOptions/DefaultHeaderResultOptions'
import { HeaderResultCommentsButton } from './HeaderResultCommentsButton/HeaderResultCommentsButton'
import { HeaderResultOption, HeaderResultOptionsButton } from './HeaderResultOptions/HeaderResultOptionsButton'
import { HeaderResultCopyAllButton } from './HeaderResultCopyAllButton/HeaderResultCopyAllButton'
import { ResultCardHeaderCRMButtons } from './ResultCardHeaderCRMButtons'

export const ResultCardHeaderButtonsWithoutEdit: React.FC<ResultCardHeaderButtonsProps> = ({
  className,
  aiFeature,
  aiResult,
  noResults,
  extraHeaderOptions,
}) => {
  const headerResultOptions = [
    useCopyLinkHeaderResultOption(aiResult),
    useFeedbackHeaderResultOption(aiFeature, aiResult),
    useWealthboxHeaderResultOption(aiFeature, aiResult),
    useSalesforceHeaderResultOption(aiFeature, aiResult),
    useZohoHeaderResultOption(aiFeature, aiResult),
    useDynamicsHeaderResultOption(aiFeature, aiResult),
    useSmartOfficeHeaderResultOption(aiFeature, aiResult),
    useAdvisorEngineHeaderResultOption(aiFeature, aiResult),
  ].filter((resultOption): resultOption is HeaderResultOption => !!resultOption)
  const extraChildren = (
    <>
      {headerResultOptions.map(({ children }, idx) => (
        <Fragment key={idx}>{children}</Fragment>
      ))}
      {extraHeaderOptions ? extraHeaderOptions.map(({ children }, idx) => <Fragment key={idx}>{children}</Fragment>) : null}
    </>
  )

  return (
    <div className={`d-flex py-2 align-items-center gap-2 ${className ?? ''}`}>
      <HeaderResultCommentsButton aiFeature={aiFeature} aiResult={aiResult} />
      <HeaderResultCopyAllButton aiFeature={aiFeature} aiResult={aiResult} />
      <ResultCardHeaderCRMButtons aiFeature={aiFeature} aiResult={aiResult} />
      <HeaderResultOptionsButton disabled={noResults} resultOptions={[...headerResultOptions, ...(extraHeaderOptions || [])]} />
      {extraChildren}
    </div>
  )
}
